import validUrl from 'valid-url';
import { dimensions } from 'gazelle/src/core/analytics/ga-custom-defs';

export const name = 'SignInController';

export default function SignInController(
  $gzEULA,
  rnAuthService,
  rnSession,
  rnLocalStorage,
  $translate,
  $state,
  $stateParams,
  $window,
  $location,
  $q,
  $gzAnalytics,
  rnHttp,
  rnUser,
  rnPreferences,
  rnApplication,
  rnFeature,
  rnClient,
  $gzHpId,
  rnStart,
  moment,
  rnRegistry,
  $mdDialog,
  $stStations,
  $timeout
) {
  //noinspection BadExpressisionStatementJS
  'ngInject';

  let signOutRequested = false;
  let promptForAccount = false;
  let autoForward = false;
  let myParams = {};

  // Welcome Page
  const WELCOME_URL = '/home/#/welcome';
  const GETTING_STARTED_URL = '/home/#/start';
  let firstTimeUser = false;
  let applications = [];
  let isInvite = false;

  let vm = this;
  vm.loading = true;
  vm.submitting = false;
  vm.hpidHelp = false;
  vm.isTrustedStation = false;
  vm.helpCenterEnabled = false;

  // controller functions
  vm.signin = signin;
  vm.signinAltUsername = signinAltUsername;
  vm.openSupportRequest = openSupportRequest;
  vm.hpidHelpClicked = hpidHelpClicked;
  vm.signUp = signUp;
  vm.oeeCheckIn = oeeCheckIn;
  vm.focusSignIn = focusSignIn;

  vm.unitTest = {
    parseParams,
    launchPrintOS,
    ensureContext,
    handleError,
    signInAnalytics,
    getSignOutRequested: () => signOutRequested,
    getMyParams: () => myParams,
    setApplications: apps => applications = apps,
    setStartInfo: value => startInfo = value,
  };

  activate();

  ////////////////////////
  function activate() {
    detectUnsupportedBrowsers();
    getHelpCenterEnabledRegistryKey();
    parseParams();
    $timeout(() => {
      focusSignIn();
    }, 400);
    // If signOut requested
    if (signOutRequested) {
      signout();
    }
    else {
      initialize();
    }
  }

  function focusSignIn() {
    let myContainer = $window.document.getElementById('btn-signin');
    if (myContainer) {
      myContainer.focus();
    }
  }

  function detectUnsupportedBrowsers() {
    vm.isUnsupportedBrowser =  ($window.navigator.userAgent.indexOf("MSIE") !== -1) || ($window.navigator.userAgent.indexOf("rv:11") !== -1);
  }

  function detectTrustedStationSecret(){
    return $stStations.hasKey().then(isTrustedStation => {
      vm.isTrustedStation = isTrustedStation;
    });
  }

  function parseParams() {
    let urlParams = $location.search();
    if ($stateParams.signout || urlParams.signout) {
      signOutRequested = true;
    }

    if ($stateParams.forward) {
      autoForward = true;
    }

    if($stateParams.chooseAccount || urlParams.chooseAccount) {
      promptForAccount = true;
    }

    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }

    myParams.data = $stateParams.data;
    if (urlParams.target) {
      _.set(myParams, 'data.target.url', $window.decodeURIComponent(urlParams.target));
    }

    if ( urlParams.statusCode && (urlParams.statusCode !== 200) ) {
      _.set(myParams, 'data.error.statusCode', urlParams.statusCode);
      _.set(myParams, 'data.error.subCode', urlParams.subCode);
    }

    isInvite = _.get(myParams, 'data.invitationId', false) ? true : false;
    vm.messageKey = _.get(myParams, 'data.target.messageKey', urlParams.messageKey);
    vm.messageParams = _.get(myParams, 'data.target.messageParams', urlParams.messageParams);
  }

  function initialize() {
    rnUser.validateUserToken().then(data => {
      if (_.get(myParams, 'data.error.statusCode')) {
        // let statusCode = parseInt(_.get(myParams, 'data.error.statusCode'));
        // let subCode = parseInt(_.get(myParams, 'data.error.subCode'));
        //
        // handleError(statusCode, subCode);
        delete myParams.data.error;
      }
      else {
        return initLaunch({data: data, reportLogin: false});
      }
    }).catch(() => {
      // User not signed in
      let promises = [];
      promises.push(detectTrustedStationSecret());
      $q.all(promises).then(() => {
      }).catch(() => {
        // don't care
      }).finally(() => {
        if (!autoForward) {
          vm.loading = false;
        }

        let loadingFinished = $window.performance.now();
        $window.ga('send', {
          hitType: 'timing',
          timingCategory: 'register',
          timingVar: 'sign-in',
          timingValue: loadingFinished
        });

        if (_.get(myParams, 'data.error.statusCode')) {
          let statusCode = parseInt(_.get(myParams, 'data.error.statusCode'));
          let subCode = parseInt(_.get(myParams, 'data.error.subCode'));

          handleError(statusCode, subCode);
        } else if (autoForward) {
          signin();
        }
      });
    });
  }

  function handleError(statusCode, subCode) {
    $gzAnalytics.event('Sign In - error', {label: `${statusCode} - ${subCode}`});

    switch(statusCode) {
      case 401:
        switch(subCode) {
          case 1000: // Need to accept EULA
            firstTimeUser = true;
            $gzEULA.show(true, null, true).then((result) => {
              vm.submitting = true;
              _.set(vm, 'signInData.eulaVersion', result.eulaVersion);
              signin();
            })
              .catch(() => {
                vm.errorKey = 'register.register.SignIn_Error_EulaNotAccepted';
              });
            break;
          case 1003: // Account is locked
            displayErrorAndForceLogin('register.register.SignIn_Error_AccountLocked');
            break;
          case 1016: // Need to accept NEW EULA
            $gzEULA.show(true, null, true, true).then((result) => {
              vm.submitting = true;
              _.set(vm, 'signInData.eulaVersion', result.eulaVersion);
              signin();
            })
              .catch((result) => {
                vm.submitting = true;
                _.set(myParams, 'signout', true);
                $state.go('signin', myParams);
              });
            break;
          case 1026: // Not enabled in HP ID
            displayErrorAndForceLogin('register.register.SignIn_Error_NotEnabledInHPID');
            break;
          case 1027: // Unsupported identity provider
            displayErrorAndForceLogin('register.register.SignIn_Error_UnsuportedIdentityProvider');
            break;
          case 1032: // Did not accept EULA
            displayErrorAndForceLogin('register.register.SignIn_Error_EulaNotAccepted');
            break;
          case 1040: // Expired or missing session key id
            displayErrorAndForceLogin('register.register.SignIn_Error_ExpiredOrMissingSessionKeyId');
            break;
          default: // Unmapped 401 Error
            vm.errorKey = 'register.register.SignIn_Error_Unknown';
            break;
        }
        break;
      case 404:
        switch (subCode) {
          case 1023: // HPID Link Expired
            displayErrorAndForceLogin('register.register.SignIn_Error_HPID_Link_Expired');
            signin();
            break;
          case 1024: // User is not in PrintOS
            vm.errorValues = [$stateParams.username];
            vm.altUsernames = _.get($stateParams, 'altUsername');

            if(vm.altUsernames) {
              if(!Array.isArray(vm.altUsernames)) {
                vm.altUsernames = [vm.altUsernames];
              }

              $gzAnalytics.eventClick('Sign In - Showing alternate usernames', {label: vm.altUsernames.length});
              vm.forceLogin = true;
            } else {
              displayErrorAndForceLogin('register.register.SignIn_Error_SignInWithDifferentHPID');
            }
            break;
          default: // Unmapped 404 Error
            vm.errorKey = 'register.register.SignIn_Error_Unknown';
            break;
        }
        break;
      case 500:
        switch (subCode) {
          case 1025:
            displayErrorAndForceLogin('register.register.SignIn_Error_Unknown');
            break;
          case 1026:
            displayErrorAndForceLogin('register.register.SignIn_Error_NoAvailableContexts');
            break;
          default: // Unmapped 500 Error
            displayErrorAndForceLogin('register.register.SignIn_Error_Unknown');
            break;
        }
        break;
      default: // Unknown Error
        vm.errorKey = 'register.register.SignIn_Error_Unknown';
        break;
    }
  }

  function displayErrorAndForceLogin(errMsg) {
    vm.forceLogin = true;
    vm.errorKey = errMsg;
  }

  function signinAltUsername(altUsername) {
    $stateParams.username = altUsername;
    signin();
    $gzAnalytics.eventClick('Sign In - Alternate username clicked');
  }

  function signin(type = 'login') {
    vm.submitting = true;
    delete vm.errorKey;

    //send analytics event when user clicks on sign in button if trusted station has been detected
    if(vm.isTrustedStation){
      $gzAnalytics.eventClick('Trusted station configuration detected - Sign in clicked');
    }

    $gzAnalytics.eventClick('Sign In - Sign in clicked');

    let returnUrl = $gzHpId.createTargetUrl($state.current.name, {
      messageKey: vm.messageKey,
      messageParams: vm.messageParams,
      target: _.get(myParams, 'data.target.url'),
    });

    let params = {
      // (if eulaVersion is null it won't be sent)
      eulaVersion: _.get(vm, 'signInData.eulaVersion'),
      locale: vm.locale,
      username: $stateParams.username,
      userId: $stateParams.userId,
      orgId: $stateParams.orgId,
    };

    if (vm.forceLogin) {
      params.forceLogin = true;
      vm.forceLogin = false;
    }

    return $gzHpId.redirect(type, returnUrl, params).catch(() => {
      vm.submitting = false;
      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
    });
  }

  function oeeCheckIn(){
    if (vm.submitting) {
      return;
    }
    $gzAnalytics.eventClick('OEE Sign In clicked');
    $window.location.href = '/oee';
  }

  function initLaunch(analyticsData) {
    // Must ensure a valid context before continuing (not something you can do in parallel)
    if (isInvite) {
      launchPrintOS();
    }
    else {
      return ensureContext().then(() => {
        let promises = [];
        if (analyticsData) {
          promises.push(signInAnalytics(analyticsData));
        }

        promises.push(getStartInfo());
        promises.push(getApplications());
        $q.all(promises).then(() => {
          launchPrintOS();
        }).catch(() => {
          vm.errorKey = 'register.register.SignIn_Error_UnknownLaunch';
          vm.loading = false;
        });
      });
    }
  }

  let startInfo;
  function getStartInfo() {
    return rnStart.getStartInfo().then(resp => {
      startInfo = resp;
    });
  }

  function getApplications() {
    return rnApplication.getFullApps(true).then(function(apps) {
      applications = apps;
    });
  }

  function getOrg() {
    return rnHttp.get('aaa', 'organizations', { cache: true })
      .then(resp => {
        return resp.data;
      });
  }

  function signInAnalytics(signInResponse) {
    let promises = [];
    let org;
    let rolesResponse;
    let clientConfig;
    promises.push(getOrg().then(orgData => {
      org = orgData;
    }));

    promises.push(rnUser.getSelectedUserRoles().then(resp => {
      rolesResponse = resp;
    }));

    promises.push(rnClient.getConfig(false).then(config => {
      clientConfig = config;
    }));

    return $q.all(promises).finally(() => {
      let userId = signInResponse.data.user.userId;

      let orgId = signInResponse.data.context.id;
      if (clientConfig.managingContext) {
        orgId = clientConfig.managingContext.id;
      }

      let userRoleNames = [];
      _.forEach(rolesResponse.userRoles, role => {
        let contextId = _.get(role, 'context.id', undefined);
        let systemRole = _.get(role, 'systemRole.name', undefined);
        if (contextId && contextId === orgId && systemRole) {
          userRoleNames.push(systemRole);
        }
      });

      let rolesString = userRoleNames.join('|');

      // Set custom dimension1 for user id (UID)
      $window.ga('set', dimensions.uid, userId);

      // Set custom dimension2 for organization id (ORGID)
      let analyticsUserId = userId;
      if (orgId) {
        $window.ga('set', dimensions.orgId, orgId);
        analyticsUserId = orgId + '|' + userId;
      }

      $gzAnalytics.setUserName(userId);

      // Set custom dimension4 for user role names
      if (rolesString) {
        $window.ga('set', dimensions.roles, rolesString);
      }

      if (!clientConfig.managingContext) {
        let selfProvisioned = _.get(org, 'anonymous', undefined) ? "true" : "false";
        // Set custom dimension6 for selfProvisioned (Use string, not Boolean "true" or "false")
        $window.ga('set', dimensions.selfProvisioned, selfProvisioned);
      }

      // Set custom dimension7 for the entity type (ENTITY TYPE), always user through sign in
      $window.ga('set', dimensions.entityType, 'User');

      $gzAnalytics.event(signInResponse.reportLogin ? 'login' : 'launch', {category: 'start', label: analyticsUserId});
    });
  }

  function signUp() {
    $state.go('signup', myParams);
    $gzAnalytics.eventClick('Sign In - Sign Up clicked');
  }

  function openSupportRequest() {
    _.set(myParams, 'fromState', 'signin');
    $state.go('support', myParams);
  }

  function ensureContext() {
    let promises = [];
    promises.push(rnClient.getConfig());
    promises.push(rnSession.availableContexts());
    promises.push(rnSession.userContext());
    return $q.all(promises).then(([clientConfig, contextData, userContext]) => {
      let contexts = contextData.contexts;

      let urlRequestedContext;
      if ((clientConfig.entity.id === $stateParams.userId) && $stateParams.orgId) {
        urlRequestedContext = contexts.find(c => c.id === $stateParams.orgId);
      }

      if (contexts.length === 0) {
        displayErrorAndForceLogin('register.register.SignIn_Error_NoAvailableContexts');
        vm.submitting = false;
        vm.loading = false;
        return $q.reject(vm.errorKey);
      }
      else if (contexts.length === 1) {
        // If we have one context then we can set the user context to that and go
        if (_.get(userContext, 'id') === contexts[0].id) {
          return;
        }

        return rnSession.switchContext(contexts[0]);
      }
      else if (_.get(userContext, 'id') && !promptForAccount && !urlRequestedContext) {
        // If multiple accounts (Existing session)
        // we can just use the user context if we are not supposed to prompt
        return;
      }

      let targetContext = userContext;
      // If we are an HP Inc. account we need to target that as a priority
      let hpContext = _.find(contexts, {name: 'HP Inc.'});
      if (hpContext) {
        targetContext = hpContext;
      }

      if (urlRequestedContext) {
        targetContext = urlRequestedContext;
      }

      if (promptForAccount || !_.get(targetContext, 'id')) {
        // Prompt the user to choose context
        return $mdDialog.show({
          clickOutsideToClose: false,
          escapeToClose: true,
          template: require('./select-account/select-account.jade'),
          controller: 'SelectAccountController',
          bindToController: true,
          controllerAs: 'vm',
          locals: {
            contexts: contexts,
            targetContext: targetContext,
          }
        }).then(selectedContext => {
          if (selectedContext.id !== _.get(userContext, 'id')) {
            return rnSession.switchContext(selectedContext);
          }
        })
          .catch(() => {
            // Account selection was cancelled...just return
            vm.forceLogin = true;
            vm.submitting = false;
            vm.loading = false;
            return $q.reject();
          });
      }

      return rnSession.switchContext(targetContext);
    });
  }

  function launchPrintOS() {
    let targetState = _.get(myParams, 'data.target.state', undefined);
    if (targetState) {
      delete myParams.signout;
      $state.go(targetState, myParams);
      return;
    }

    goToTargetUrl();
  }

  function goToTargetUrl() {
    let target = _.get(myParams, 'data.target.url');
    if (!validUrl.isWebUri(target)) {
      if (startInfo.hasIncompleteSteps) {
        target = GETTING_STARTED_URL;
      }
      else if (startInfo.showWelcome) {
        target = WELCOME_URL;
      }
      else {
        let defaultApp = _.find(applications, {appId: startInfo.defaultAppId});
        if (!defaultApp) {
          // TODO: consider setting preference to home since default app not found
          defaultApp = _.find(applications, {appId: 'home'});
        }

        target = defaultApp._links.self;
      }
    }

    $window.location.href = target;
  }

  function signout() {
    if(!__DEV__) {
      $gzAnalytics.event('logout', { category: 'register'});
    }

    vm.submitting = true;
    let params = {
      messageKey: vm.messageKey,
      messageParams: vm.messageParams,
      statusCode: null,
      subCode: null,
    };

    // Remember target if we are forcing a signout
    let targetURL = _.get(myParams, 'data.target.url');
    if (targetURL) {
      params.target = targetURL;
    }

    let returnUrl = $gzHpId.createTargetUrl($state.current.name, params);
    return $gzHpId.redirect('logout', returnUrl, {}).catch(() => {
      vm.submitting = false;
      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
    });
  }

  function hpidHelpClicked(){
    vm.hpidHelp = !vm.hpidHelp;
      if (vm.hpidHelp) {
        $gzAnalytics.eventClick('HPID - Help opened');
      }
      else {
        $gzAnalytics.eventClick('HPID - Help closed');
      }
  }

  function getHelpCenterEnabledRegistryKey() {
    rnRegistry.getRegistry().then(registry => {
      vm.helpCenterEnabled = registry.keys.helpCenterEnabled;
    });
  }
}



// WEBPACK FOOTER //
// ./components/sign-in/sign-in.controller.js